import { FormState } from 'final-form';
import { Dispatch } from 'react';

import { IKnmTypeSelectOption } from '../../../CorePackage/CatalogsModule/interfaces/IKnmTypeSelectOption';
import { IDictionaryKnmKindSelectOption } from '../../../CorePackage/DictionariesModule/interfaces/IDictionaryKnmKindSelectOption';
import { IApproveRequiredSelectOption } from '../interfaces/IApproveRequiredSelectOption';
import { IKnmForm } from '../../../KnmPackage/MainModule/interfaces/IKnmForm';
import { knmInfoGetExcludeDates } from '../../../KnmPackage/MainModule/actions/knmActions';
import { IKnmFormRef } from '../../../KnmPackage/MainModule/interfaces/IKnmFormRef';
import { RootActions } from '../../../CorePackage/MainModule/types/RootActions';
import { IKnmReasonTypeSelectOption } from '../../../CorePackage/CatalogsModule/interfaces/IKnmReasonTypeSelectOption';

export const subscribeGetExcludeDates = (
  formRef: IKnmFormRef | undefined,
  dispatch: Dispatch<RootActions>,
  isNewKnm: boolean,
) => {
  let typeErknmCache: IKnmTypeSelectOption | undefined;
  let kindKnmCache: IDictionaryKnmKindSelectOption | undefined;
  let approveRequiredCache: IApproveRequiredSelectOption | undefined;
  let reasonTypeCache: IKnmReasonTypeSelectOption | undefined;

  formRef?.current.subscribe(
    (state: FormState<IKnmForm, Partial<IKnmForm>>) => {
      const { typeErknm, kindKnm, approveRequired, reasonsErknm, startDate } = state.values;
      const reasonType = reasonsErknm
        ?.filter(item => item.ervkUuid)
        .map(item => item.type)
        .find(type => type);

      if (
        typeErknm !== typeErknmCache ||
        kindKnm !== kindKnmCache ||
        approveRequired !== approveRequiredCache ||
        reasonType !== reasonTypeCache
      ) {
        dispatch(
          knmInfoGetExcludeDates({
            approveRequiredCode: approveRequired?.id ?? '',
            kindCode: kindKnm?.code ?? '',
            typeCode: typeErknm?.code ?? '',
            reasonTypeId: reasonType?.id,
            reasonName: reasonType?.name,
            selectedStartDate: startDate,
            isNewKnm,
          }),
        );
      }
      typeErknmCache = typeErknm;
      kindKnmCache = kindKnm;
      approveRequiredCache = approveRequired;
      reasonTypeCache = reasonType;
    },
    { values: true },
  );
};
